import type { July4848PromoVariant } from '../constants/july-48-48-promo';

/**
 * CONENG-2513 sitewide sale variants map to Sanity `promotionId` values (currency-restricted in CMS).
 * Gate on `promotionId` — never on `promoCode`, which is the mutable Braavos coupon at checkout.
 *
 * G1 (`48july48`) — full-price markets, 50% off. G2 (`48july10`) — new-price markets, 10% off.
 */
export const JULY_48_48_PROMO_G1_PROMOTION_ID = '48july48';
export const JULY_48_48_PROMO_G2_PROMOTION_ID = '48july10';

export type July4848PromoMarketTier = 'full' | 'low';

export function getJuly4848PromoMarketTier(variant: July4848PromoVariant): July4848PromoMarketTier {
  return variant === 'g2' ? 'low' : 'full';
}

export function getJuly4848PromoVariant(promotionId: string | null | undefined): July4848PromoVariant | null {
  if (promotionId === JULY_48_48_PROMO_G1_PROMOTION_ID) {
    return 'g1';
  }
  if (promotionId === JULY_48_48_PROMO_G2_PROMOTION_ID) {
    return 'g2';
  }
  return null;
}

export function getJuly4848PromoSlideKey(variant: July4848PromoVariant): string {
  return `july-48-48-promo-${variant}`;
}

/** `?force_promo=<promotionId>` wins over the live `usePromotion` response (preview QA only). */
export function resolveJuly4848PromoVariant(
  forcedPromotionId: string | null | undefined,
  promotionId: string | null | undefined
): July4848PromoVariant | null {
  return getJuly4848PromoVariant(forcedPromotionId) ?? getJuly4848PromoVariant(promotionId);
}
